module.exports = __webpack_public_path__ + "static/media/honor-img7.3bcd914b.png";